import { Vue, Component, Emit, Prop } from "vue-property-decorator";
import { BButton, VBTooltip } from "bootstrap-vue";
import { ITableFilter } from "@lib";
import AltAutoButton from "@/core/components/alt-auto-button";
import FilterModal from "@core/filters/filter-modal.vue";
import { CompaniesFilterController } from "../companies-filter-controller";

@Component({
    name: "clients-toolbar",
    components: {
        BButton,
        AltAutoButton,
        FilterModal,
    },
    directives: { "b-tooltip": VBTooltip },
})
export default class CompaniesToolbar extends Vue {
    @Prop({ type: Object, required: true })
    public filterController!: CompaniesFilterController;

    @Prop({ type: Array, default: () => [] })
    private filter!: ITableFilter[];

    @Emit("refresh")
    private startRefresh(): void {
        return;
    }

    @Emit("export")
    private startExport(): void {
        return;
    }

    @Emit("show-filter")
    public showFilterModal(): void {
        return;
    }

    private get hasFilter(): boolean {
        return this.filter.length > 0;
    }
}
